module.exports = __webpack_public_path__ + "static/media/Tulleord-instruksjoner-Dysmate-A.6f76b7a8.mp3";